module.exports = __webpack_public_path__ + "img/other-docs-mob.22cd959e.svg";